import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { API } from "../App";
import { toast } from "sonner";

const navHTML = `
<style>
@media (max-width: 991px) { 
    .desktop-nav { display: none !important; } 
    .header-inner-grid { grid-template-columns: 1fr !important; }
}
@media (min-width: 992px) { .menu-button { display: none !important; } }
</style>
<div class="page-wrapper"><div data-animation="default" data-collapse="all" data-duration="0" data-easing="ease" data-easing2="ease" role="banner" class="navbar w-nav"><div class="padding-global"><div class="container-large w-container"><div class="navbar-content-wrapper"><a href="/" class="logo-link w-nav-brand w--current" aria-label="home"><div style="font-size: 1.25rem; font-weight: 700; color: #274c77; letter-spacing: -0.02em;">CA Ronak Patel</div></a><div class="desktop-nav" style="display: flex; gap: 2.5rem; align-items: center;"><a href="/" style="color: #475569; font-weight: 500; font-size: 1rem; text-decoration: none;">Home</a><a href="/#services" style="color: #475569; font-weight: 500; font-size: 1rem; text-decoration: none;">Services</a><a href="/#software" style="color: #475569; font-weight: 500; font-size: 1rem; text-decoration: none;">Software</a><a href="/#faq" style="color: #475569; font-weight: 500; font-size: 1rem; text-decoration: none;">FAQ</a><a href="/#contact" style="color: #475569; font-weight: 500; font-size: 1rem; text-decoration: none;">Contact</a><a href="/login" style="background-color: #274c77; color: white; padding: 0.5rem 1.25rem; border-radius: 0.5rem; font-weight: 600; text-decoration: none; transition: background-color 0.2s;" onMouseOver="this.style.backgroundColor='#1a365d'" onMouseOut="this.style.backgroundColor='#274c77'">Login</a></div><nav id="mobile-nav" role="navigation" class="nav-menu w-nav-menu" style="display: none; background-color: #e2e8f0; position: absolute; top: 100%; left: 0; width: 100%; z-index: 1000;"><div class="nav-menu-container" style="opacity: 1; height: auto; min-height: 100vh; padding-top: 5vh; gap: 1rem;"><a href="/" onclick="document.getElementById('mobile-nav').style.display='none'" aria-current="page" class="nav-link w-inline-block w--current"><div>Home</div><div class="arrow-button-circle" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"><div class="arrow w-embed" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path></svg></div></div></a><a href="/#services" onclick="document.getElementById('mobile-nav').style.display='none'" class="nav-link w-inline-block"><div>Services</div><div class="arrow-button-circle" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"><div class="arrow w-embed" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path></svg></div></div></a><a href="/#software" onclick="document.getElementById('mobile-nav').style.display='none'" class="nav-link w-inline-block"><div>Software</div><div class="arrow-button-circle" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"><div class="arrow w-embed" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path></svg></div></div></a><a href="/#faq" onclick="document.getElementById('mobile-nav').style.display='none'" class="nav-link w-inline-block"><div>FAQ</div><div class="arrow-button-circle" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"><div class="arrow w-embed" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path></svg></div></div></a><a href="/#contact" onclick="document.getElementById('mobile-nav').style.display='none'" class="nav-link w-inline-block"><div>Contact</div><div class="arrow-button-circle" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"><div class="arrow w-embed" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path></svg></div></div></a><a href="/login" class="nav-link w-inline-block" style="background-color: #274c77; color: white; padding: 0.5rem 1.25rem; border-radius: 0.5rem; width: auto; margin-top: 1rem;"><div style="color: white; text-align: center;">Login</div></a></div></nav><div onclick="var nav = document.getElementById('mobile-nav'); if(nav.style.display === 'none'){nav.style.display = 'flex';}else{nav.style.display = 'none';}" data-w-id="e4df2974-a7bf-d1ac-eef9-976c0620fe57" class="menu-button w-nav-button" style="-webkit-user-select: text;" aria-label="menu" role="button" tabindex="0" aria-controls="w-nav-overlay-0" aria-haspopup="menu" aria-expanded="false"><div class="inner-menu-button"><div class="menu-line-container" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"><div class="menu-line-wrap"><div class="top-dash" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"></div></div><div class="menu-line-wrap"><div class="middle-dash"></div></div><div class="menu-line-wrap"><div class="bottom-dash" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"></div></div></div></div></div></div></div></div><div class="w-nav-overlay" data-wf-ignore="" id="w-nav-overlay-0"></div></div>`;
const footerHTML = `<footer class="footer"><div class="padding-global"><div class="w-layout-blockcontainer container-large w-container"><div class="footer-padding"><div class="footer-bottom-wrapper"><div id="w-node-cd48159e-9512-c1d8-5470-7a03503e3676-503e3671" class="footer-link-block"><div class="footer_credit-text">Designed for CA Ronak Patel</div><div class="footer_credit-text">All Rights Reserved © 2026</div></div><div class="footer-link-block"><a href="/privacy-policy" class="footer-legal-link">Privacy Policy</a><a href="/terms-of-service" class="footer-legal-link">Terms of Service</a></div></div></div></div></div></footer>`;

const LoginPage = () => {
  const { loginWithGoogle, user, login } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showEmailLogin, setShowEmailLogin] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailLoading, setEmailLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (user) {
      if (user.role === "super_admin") {
        navigate("/admin");
      } else if (user.role === "team_member") {
        navigate("/team");
      } else {
        navigate("/dashboard");
      }
    }

    const navbar = document.querySelector(".navbar");
    if (navbar) {
      const links = navbar.querySelectorAll("a");
      links.forEach((link) => {
        link.addEventListener("click", (e) => {
          const href = link.getAttribute("href");
          if (!href || href.startsWith("http")) return;
          e.preventDefault();
          if (href === "/" || href === "#") {
            navigate("/");
          } else if (href.startsWith("/#")) {
            const targetId = href.split("#")[1];
            navigate("/");
            setTimeout(() => {
              const el = document.getElementById(targetId);
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }, 150);
          } else {
            navigate(href);
          }
        });
      });
    }
  }, [user, navigate]);

  const handleLogin = () => {
    setIsLoading(true);
    loginWithGoogle();
  };

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error("Email and password are required"); return; }
    setEmailLoading(true);
    try {
      const res = await fetch(`${API}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
        credentials: "include",
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("session_token", data.token);
        login(data.user);
        toast.success("Logged in successfully");
      } else {
        const err = await res.json();
        toast.error(err.detail || "Login failed");
      }
    } catch {
      toast.error("Login error");
    } finally {
      setEmailLoading(false);
    }
  };

  return (
    <div style={{ backgroundColor: "#e2e8f0", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <div dangerouslySetInnerHTML={{ __html: navHTML }} />
      
      <main className="main-wrapper" style={{ flexGrow: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "4rem 1rem" }}>
        <div className="shadow-box medium-padding" style={{ width: "100%", maxWidth: "450px", backgroundColor: "#ffffff", borderRadius: "16px", padding: "3rem 2rem", textAlign: "center", borderTop: "4px solid #F37920" }}>
          
          <div style={{ marginBottom: "2rem" }}>
            <h2 className="heading-style-h1" style={{ fontSize: "1.75rem", color: "#145886", marginBottom: "0.5rem" }}>Welcome back</h2>
            <p style={{ color: "#475569", fontSize: "0.9rem" }}>CA Ronak Patel, Chartered Accountant</p>
          </div>

          <div style={{ height: "1px", backgroundColor: "#e2e8f0", margin: "1.5rem 0" }} />

          <div style={{ marginBottom: "1.5rem" }}>
            <button
              onClick={handleLogin}
              disabled={isLoading}
              style={{
                width: "100%",
                backgroundColor: "#145886",
                color: "white",
                fontWeight: "bold",
                padding: "1rem",
                borderRadius: "8px",
                border: "none",
                cursor: isLoading ? "not-allowed" : "pointer",
                opacity: isLoading ? 0.7 : 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.75rem",
                transition: "background-color 0.2s"
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#0e4068'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#145886'}
            >
              {isLoading ? (
                <span>Connecting...</span>
              ) : (
                <>
                  <svg style={{ width: "20px", height: "20px" }} viewBox="0 0 24 24" fill="currentColor">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                  </svg>
                  <span>Continue with Google</span>
                </>
              )}
            </button>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "1rem", margin: "1.5rem 0" }}>
            <div style={{ flex: 1, height: "1px", backgroundColor: "#e2e8f0" }} />
            <span style={{ fontSize: "0.75rem", color: "#94a3b8", textTransform: "uppercase" }}>or</span>
            <div style={{ flex: 1, height: "1px", backgroundColor: "#e2e8f0" }} />
          </div>

          <div>
            {!showEmailLogin ? (
              <button
                onClick={() => setShowEmailLogin(true)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#475569",
                  cursor: "pointer",
                  fontSize: "0.9rem",
                  textDecoration: "underline"
                }}
              >
                Sign in with Email & Password
              </button>
            ) : (
              <form onSubmit={handleEmailLogin} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email address"
                  style={{ width: "100%", padding: "0.75rem 1rem", borderRadius: "8px", border: "1px solid #e2e8f0", backgroundColor: "#f8fafc", fontSize: "0.9rem", boxSizing: "border-box" }}
                />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  style={{ width: "100%", padding: "0.75rem 1rem", borderRadius: "8px", border: "1px solid #e2e8f0", backgroundColor: "#f8fafc", fontSize: "0.9rem", boxSizing: "border-box" }}
                />
                <button
                  type="submit"
                  disabled={emailLoading}
                  style={{
                    width: "100%",
                    backgroundColor: "#55B848",
                    color: "white",
                    fontWeight: "bold",
                    padding: "0.75rem",
                    borderRadius: "8px",
                    border: "none",
                    cursor: emailLoading ? "not-allowed" : "pointer",
                    opacity: emailLoading ? 0.7 : 1,
                    transition: "background-color 0.2s"
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#47a33c'}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#55B848'}
                >
                  {emailLoading ? "Signing in..." : "Sign In"}
                </button>
              </form>
            )}
          </div>

        </div>
      </main>

      <div dangerouslySetInnerHTML={{ __html: footerHTML }} />
    </div>
  );
};

export default LoginPage;
